import React, { Component } from 'react';
import { connect } from 'react-redux';
import { benefitRedeemService } from '../../services/benefitRedeem.service';
import './Upspi26V2.scss';

class Upspi26V2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      screen: 'loading',
      customerType: null,
      codeDigits: ['', '', '', ''],
      errorText: '',
      isSubmitting: false,
    };
    this.campaignId = null;
  }

  componentDidMount() {
    const campaignId = process.env.REACT_APP_BENEFIT_CAMPAIGN_ID;
    if (!campaignId) {
      this.setState({ screen: 'error' });
      return;
    }
    this.campaignId = campaignId;

    const { profile } = this.props;
    if (profile?.userId) {
      this.checkEligibility();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.profile?.userId && this.props.profile.userId !== prevProps.profile?.userId) {
      if (this.campaignId) {
        this.checkEligibility();
      }
    }
  }

  checkEligibility = () => {
    benefitRedeemService
      .checkEligibility(this.campaignId)
      .then((data) => {
        const statusMap = {
          eligible: 'authorized',
          already_redeemed: 'redeemed',
          not_eligible: 'notfound',
          not_register: 'notregister',
          campaign_unavailable: 'notfound',
          campaign_not_in_period: 'notfound',
        };

        const screen = statusMap[data.status] || 'notfound';
        const customerType = data.customer?.type || null;

        this.setState({ screen, customerType });
      })
      .catch((err) => {
        this.setState({ screen: 'notfound' });
      });
  };

  handleDigitChange = (idx, e) => {
    const v = e.target.value.replace(/\D/g, '').slice(-1);
    const codeDigits = [...this.state.codeDigits];
    codeDigits[idx] = v;

    this.setState({ codeDigits, errorText: '' }, () => {
      if (v && idx < 3 && this[`digit${idx + 1}`]) {
        this[`digit${idx + 1}`].focus();
      }
    });
  };

  handleKeyDown = (idx, e) => {
    if (e.key === 'Backspace' && !e.target.value && idx > 0) {
      if (this[`digit${idx - 1}`]) {
        this[`digit${idx - 1}`].focus();
      }
    }
  };

  handleSubmit = () => {
    const { codeDigits, isSubmitting } = this.state;
    const passComplete = codeDigits.every(Boolean);

    if (!passComplete || isSubmitting) return;

    const code = codeDigits.join('');

    this.setState({ isSubmitting: true, errorText: '' });

    benefitRedeemService
      .redeem(this.campaignId, code)
      .then((data) => {
        if (data.success === true) {
          this.setState({ screen: 'redeemed' });
        } else if (data.message === 'คุณใช้สิทธิ์ไปแล้ว') {
          this.setState({ screen: 'redeemed' });
        } else if (data.message === 'รหัสแลกสิทธิ์ไม่ถูกต้อง') {
          this.setState({
            errorText: 'รหัสไม่ถูกต้อง กรุณาลองใหม่',
          });
        } else {
          this.setState({
            errorText: 'เกิดข้อผิดพลาด กรุณาลองใหม่',
          });
        }
      })
      .catch(() => {
        this.setState({
          errorText: 'เกิดข้อผิดพลาด กรุณาลองใหม่',
        });
      })
      .finally(() => {
        this.setState({
          isSubmitting: false,
          codeDigits: ['', '', '', ''],
        });
      });
  };

  renderBadge() {
    const { customerType } = this.state;
    if (!customerType) return null;
    return (
      <div className="upspi26v2-badge">
        {customerType.toUpperCase()}
      </div>
    );
  }

  renderCodePanel() {
    const { codeDigits, errorText, isSubmitting } = this.state;
    const passComplete = codeDigits.every(Boolean);

    return (
      <div className="upspi26v2CodePanel">
        <div className="upspi26v2CodeAgrRow">
          {codeDigits.map((v, idx) => (
            <input
              key={idx}
              ref={(el) => (this[`digit${idx}`] = el)}
              className="upspi26v2CodeInput"
              inputMode="numeric"
              type="password"
              maxLength={1}
              value={v}
              onChange={(e) => this.handleDigitChange(idx, e)}
              onKeyDown={(e) => this.handleKeyDown(idx, e)}
            />
          ))}
        </div>

        <button
          type="button"
          className={`upspi26v2SubmitBtn ${passComplete && !isSubmitting ? 'enabled' : 'disabled'}`}
          disabled={!passComplete || isSubmitting}
          onClick={this.handleSubmit}
        >
          รับของที่ระลึก
        </button>

        {errorText && (
          <div className="upspi26v2ErrorText">
            {errorText}
          </div>
        )}
      </div>
    );
  }

  renderLoading() {
    return (
      <div className="upspi26v2 fullscreen">
        <div className="bgUpspi26v2Loading" />
      </div>
    );
  }

  renderAuthorized() {
    return (
      <div className="upspi26v2 fullscreen">
        {this.renderBadge()}
        <div className="containerAuthorized">
          <div className="upspi26v2AuthorizedPage">
            <img
              className="upspi26v2GiftImg"
              src="/images/upspiration/upspi26-gif.png"
              alt=""
            />

            <div className="upspi26v2CodeText">
              ให้เจ้าหน้าที่กรอกโค้ด
              <br />
              เพื่อรับของที่ระลึก
            </div>

            {this.renderCodePanel()}
          </div>
        </div>
      </div>
    );
  }

  renderRedeemed() {
    return (
      <div className="upspi26v2 fullscreen">
        {this.renderBadge()}
        <div className="containerAuthorized">
          <div className="upspi26v2AuthorizedPage">
            <img
              className="upspi26v2GiftRedeemedImg"
              src="/images/upspiration/upspi26-redeemed.png"
              alt=""
            />
          </div>
        </div>
      </div>
    );
  }

  renderNotFound() {
    return (
      <div className="upspi26v2 fullscreen">
        {this.renderBadge()}
        <div className="containerAuthorized">
          <div className="upspi26v2AuthorizedPage">
            <img
              className="upspi26v2GiftNotfoundImg"
              src="/images/upspiration/upspi26-notfound.png"
              alt=""
            />
          </div>
        </div>
      </div>
    );
  }

  renderNotRegister() {
    return (
      <div className="upspi26v2 fullscreen">
        <div className="containerAuthorized">
          <div className="upspi26v2AuthorizedPage">
            <img
              className="upspi26v2GiftNotfoundImg"
              src="/images/upspiration/upspi26-notregister.png"
              alt=""
            />
          </div>
        </div>
      </div>
    );
  }

  renderError() {
    return (
      <div className="upspi26v2 fullscreen">
        <div className="containerAuthorized">
          <div className="upspi26v2AuthorizedPage">
            <div className="upspi26v2ErrorText">
              ไม่พบการตั้งค่าแคมเปญ กรุณาติดต่อผู้ดูแลระบบ
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { screen } = this.state;

    if (screen === 'loading') {
      return this.renderLoading();
    }

    return (
      <>
        {screen === 'authorized' && this.renderAuthorized()}
        {screen === 'redeemed' && this.renderRedeemed()}
        {screen === 'notfound' && this.renderNotFound()}
        {screen === 'notregister' && this.renderNotRegister()}
        {screen === 'error' && this.renderError()}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  profile: state.profile,
});

export default connect(mapStateToProps)(Upspi26V2);
